module.exports = __webpack_public_path__ + "static/media/guide_4.96cacf4b.svg";